import React from 'react';

import {useStore} from 'effector-react';
import {useTranslation} from 'react-i18next';

import {Button, ButtonVariant} from 'components/ui-kit/Button';
import {Modal} from 'components/ui-kit/Modal';

import {
    $invoiceDeletingPending,
    $invoiceState,
    $showDeleteInvoiceModal,
    deleteInvoiceFx,
    setShowDeleteInvoiceModal,
    setTargetStatus,
} from 'models/documents/invoices/common';

import {ModalContent, ModalMessage, ModalButtons} from './styled';

export const DeleteInvoiceModal: React.FC = () => {
    const {t} = useTranslation();
    const invoiceState = useStore($invoiceState);
    const showDeleteInvoiceModal = useStore($showDeleteInvoiceModal);
    const invoiceDeletingPending = useStore($invoiceDeletingPending);

    const PATH = 'pages.documents.invoices.deleteInvoiceModal';
    const title = t(`${PATH}.title`);
    const message = t(`${PATH}.message`);
    const confirm = t(`${PATH}.confirm`);
    const cancel = t(`${PATH}.cancel`);

    function deleteInvoice() {
        if (invoiceState && invoiceState !== 'new') {
            setTargetStatus('DELETE');
            deleteInvoiceFx(invoiceState);
        }
    }

    return (
        <Modal
            show={showDeleteInvoiceModal}
            onClose={() => setShowDeleteInvoiceModal(false)}
            closable={!invoiceDeletingPending}
            hideCloseButton={true}
            modalWidth={0}
            title={title}
        >
            <ModalContent>
                <ModalMessage>{message}</ModalMessage>
                <ModalButtons>
                    <Button
                        variant={ButtonVariant.Cancel}
                        onClick={deleteInvoice}
                        disabled={invoiceDeletingPending}
                    >
                        {confirm}
                    </Button>
                    <Button
                        variant={ButtonVariant.Outline}
                        onClick={() => setShowDeleteInvoiceModal(false)}
                        disabled={invoiceDeletingPending}
                    >
                        {cancel}
                    </Button>
                </ModalButtons>
            </ModalContent>
        </Modal>
    );
};
